import type { FC } from "react";
import { Card, Chip, Flex, Icon, Text, useHover } from "@huub-web/ui";

import type { AnalysisObservation as AnalysisObservationType } from "../../../types";
import { firstLetterCapitalStyle } from "../AnalysisObservations.css";

/**
 * @deprecated
 */
export type AnalysisObservationProps = {
  observation: AnalysisObservationType;
  disabled?: boolean;
  onClick?: () => void;
};

/**
 * @deprecated
 */
export const AnalysisObservation: FC<AnalysisObservationProps> = ({
  observation,
  disabled = false,
  onClick,
}) => {
  const { handleEnter, handleLeave /*hasHover */ } = useHover({ disabled });

  return (
    <Card
      border="default"
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      onClick={onClick}
    >
      <Flex justify="space-between" gap="s">
        <Text bold as="h4" ellipsis className={firstLetterCapitalStyle}>
          {observation.component?.replace(/_/g, " ")}
        </Text>
        <Chip
          variant="tertiary"
          className={firstLetterCapitalStyle}
          shrink={false}
        >
          {observation.assessment?.replace(/_/g, " ")}
        </Chip>
      </Flex>
      <Text variant="bodyM" markdown clamp={4} grow>
        {observation.explanation}
      </Text>
      <Flex justify="flex-end" align="flex-end" gap="s" wrap>
        <Flex>
          {observation.mediaReferences.length > 0 && (
            <Flex gap="xs">
              <Icon icon="imageFilled" color="currentColor25" size="s" />
              <Text variant="bodyS" color="currentColor25">
                {observation.mediaReferences.length}
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};
